module.exports = __webpack_public_path__ + "static/fonts/iconfont.77157a1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.woff2?t=1683809780211
// module id = Mdmi
// module chunks = 44